module.exports = __webpack_public_path__ + "img/windows.e582499f.svg";